module.exports = __webpack_public_path__ + "img/qiangdanchenggong.975b3140.svg";